import {useAuth} from 'src/contexts/AuthContext'
import {useCompany} from '../../contexts/CompanyContext'

export const ValidateUserPermissions = (permission: string): boolean => {
  const {user} = useAuth()
  if (!user) return false
  return user.permissions.includes(permission)
}

export const ValidateCompanyPermission = (permission: string, companyId: number): boolean => {
  const {companies} = useCompany()
  const companyToValidate = companies.find((it) => it.id === companyId)
  const permissionsOnCompany = companyToValidate?.permissions?.map((it) => it.codename)
  if (!companyToValidate || !permissionsOnCompany?.length) return false
  return permissionsOnCompany.includes(permission)
}

export const VerifyUserAndCompanyPermission = (companyIds: number[], permission: string) => {
  const {companies} = useCompany()
  const {user} = useAuth()

  const companiesToValidate = companies.filter((it) => companyIds.includes(it.id))

  if (!companiesToValidate) return false

  const userHasPermission = user.permissions.includes(permission)
  const companyHasPermission = companiesToValidate?.some((company) => company.permissions?.map((permission) => permission.codename).includes(permission))
  return userHasPermission && companyHasPermission
}
